import { createContext, useContext, useState, useEffect } from 'react';
import ko from '../Locales/ko.json';
import en from '../Locales/en.json';

const translations = { ko, en };

const LanguageContext = createContext();
const languageChannel = new BroadcastChannel('language-preview');

const VALID_LANGS = ['ko', 'en'];

function getSavedLanguage() {
  const saved = window.localStorage.getItem('language');

  return VALID_LANGS.includes(saved) ? saved : 'ko';
}

export function LanguageContextProvider({ children }) {
  const [languageMode, setLanguageMode] = useState(getSavedLanguage);

  // 다른 탭에서 언어 변경 시 동기화 //
  useEffect(() => {
    const handler = (e) => {
      if (e.data?.type === 'apply') setLanguageMode(e.data.mode);
      else if (e.data?.type === 'preview') setLanguageMode(e.data.mode);
    };
    languageChannel.addEventListener('message', handler);
    return () => languageChannel.removeEventListener('message', handler);
  }, []);

  // 언어 변경 + localStorage 저장 + 다른 탭 동기화 //
  const applyLanguage = (mode) => {
    setLanguageMode(mode);
    window.localStorage.setItem('language', mode);
    languageChannel.postMessage({ type: 'apply', mode });
  };

  const previewLanguage = (mode) => {
    setLanguageMode(mode);
    languageChannel.postMessage({ type: 'preview', mode });
  };

  const setLanguage = () => window.localStorage.setItem('language', languageMode);

  const revertLanguage = () => setLanguageMode(getSavedLanguage());


  const isEng = languageMode === 'en';

  const t = (key, params) => {
    const keys = key.split('.');
    let value = translations[languageMode];
    for (const k of keys) {
      value = value?.[k];
    }
    if (value === undefined) return key;
    if (params) {
      return Object.entries(params).reduce(
        (str, [k, v]) => str.replace(`{${k}}`, v),
        value
      );
    }
    return value;
  };

  return (
    <LanguageContext.Provider value={{ isEng, languageMode, applyLanguage, previewLanguage, setLanguage, revertLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
